<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" @stored="storeUser" :visibleStore="updatePermission">
                    <template v-slot:action="{ item }">
                        <v-btn v-if="updatePermission" class="mr-2" depressed small @click.stop="updatedUser(item)" color="primary">編集</v-btn>
                        <v-btn v-if="deletePermission && item.id != user.user_id" class="mr-2" depressed small @click.stop="deleteUser(item)" color="error">削除</v-btn>
                    </template>
                </custom-data-table>
            </v-col>
        </v-row>
        <v-row justify="center">
            <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
                @deleted="deleted" @canceled="dialogCancel"/>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import UserMasterApi from "@/api/user-master-api";
  import statusList from "@/helpers/const";

  export default {
    name: "UserMaster",
    components: {
      CustomDataTable,
      CustomDialog,
    },
    props: ["user"],
    data: () => ({
        // ユーザー一覧テーブル
        loading: false,
        tableName: "ユーザー情報",
        headers: [
            { text: "ユーザーID", value: "email", sortable: false },
            { text: "ユーザー名", value: "user_name", sortable: false },
            { text: "所属部署", value: "department_name", sortable: false },
            { text: "所属課", value: "department_section", sortable: false },
            { text: "ユーザー権限", value: "permission_name", sortable: false },
            { text: "アクション", value: "action", sortable: false }
        ],
        items: [],

        // 削除ダイアログ
        dialogMaxWith: 500,
        dialogTitle: "",
        dialogItems: [],
        dialogDrawer: false,
        deleteId: null,

        // 権限
        updatePermission: true,
        deletePermission: true
    }),
    created() {
        this.initialize();
    },
    methods: {
        isLoading() {
            this.loading = !this.loading;
            this.$emit("loading", this.loading);
        },
        initialize() {
            this.isLoading();
            if (this.user.role_id == 0) {
                this.updatePermission = this.user.permission_config.CTSG00004.update;
                this.deletePermission = this.user.permission_config.CTSG00004.delete;
            }
            this.userMasterApi = new UserMasterApi();
            const promise = this.userMasterApi.list();
            promise.then((response) => {
                this.items = response.data.body.user_list;
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if (error.response) {
                    if (error.response.data.status == statusList.status.authError) {
                        this.$emit('logoutConform');
                    } else if (error.response.data.status == statusList.status.entityError) {
                        this.$emit("error",error.response.data.message);
                        this.$router.push({ name: "Dashboard" })
                    } else {
                        this.$emit("error",error.response.data.message);
                    }
                } else {
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        },
        storeUser() {
            this.$router.push({ name: 'UserMasterEntry' });
        },
        updatedUser(item) {
            this.$router.push({ name: 'UserMasterEdit', params: { id: item.id } });
        },
        deleteUser(item) {
            this.deleteId = item.id;
            this.dialogTitle = '削除しますか？';
            this.dialogItems = [
                { name: "ユーザーID", value: item.email },
                { name: "ユーザー名", value: item.user_name },
                { name: "所属部署", value: item.department_name },
                { name: "ユーザー権限", value: item.permission_name },
            ];
            this.dialogDrawer = true;
        },
        dialogCancel() {
            this.dialogDrawer = false;
        },
        deleted() {
            this.isLoading();
            const promise = this.userMasterApi.delete(this.deleteId);
            promise.then((response) => {
                this.items = this.items.filter((item) => {
                    return (item.id !== this.deleteId);
                });
                this.deleteId = null;
                this.dialogDrawer = false;
                this.$emit('success', response.data.message);
            }).catch(error => {
                useAppInsights().trackException({exception: error});
                if (error.response) {
                    if (error.response.data.status == statusList.status.authError) {
                        this.dialogDrawer = false;
                        this.$emit('logoutConform');
                    } else {
                        this.$emit("error",error.response.data.message);
                    }
                } else {
                    this.$emit("error","サーバーエラーが発生しました。");
                }
            }).finally(() => {
                this.isLoading();
            });
        }
    }
  };
</script>
